export function timeslotsPrettyPrint(timeslots) {
  var prevTimeSlotDay = null;
  var output = '';
  var seenSlots = [];
  var DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
  timeslots = timeslots.slice()
  timeslots.sort((a, b) => a.cycle_day_index - b.cycle_day_index || a.startMin - b.startMin)
  timeslots.forEach(timeslot => {
    if (seenSlots.indexOf(timeslot) !== -1)
      return
    if (timeslot.cycle_day_index == prevTimeSlotDay) {
      output += '&';
    } else {
      output += ', ' + DAYS[Number(timeslot.cycle_day_index) - 1] + ' ';
    }
    var short = timeslot.short_name;
    if (['1', '2', '3', '4', '5', '6', '7'].indexOf(short) !== -1)
      output += 'L' + short;
    else if (short == 'T')
      output += 'Tutor'
    else
      output += (timeslot.name || short);
    prevTimeSlotDay = timeslot.cycle_day_index;
    seenSlots.push(timeslot);
  });
  output = output.substr(2);
  return output
}

export function closest(el, selector) {
  var matchesFn;
  ['matches',
    'webkitMatchesSelector',
    'mozMatchesSelector',
    'msMatchesSelector',
    'oMatchesSelector'].some(function (fn) {
      if (typeof document.body[fn] == 'function') {
        matchesFn = fn;
        return true;
      }
      return false;
    })

  // traverse parents
  while (el) {
    if (el && el[matchesFn](selector)) {
      return el;
    }
    el = el.parentElement;
  }

  return null;
}

export function throttle(func, wait) {
  var context, args, result;
  var timeout = null;
  var previous = 0;

  var later = function () {
    previous = +new Date();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function () {
    var now = +new Date();
    if (!previous) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
};

export function sortBy(field, options) {
  // read options into locals — the caller sometimes passes reactive state
  // (SortableMixin.sortParameters), and mutating the argument writes into it.
  options = options || {};
  var insensitive = options.insensitive || false;
  var trim = options.trim || false;
  var reverse = options.reverse || false;
  return (a, b) => {
    var aField, bField;
    if (typeof field == 'function') {
      aField = field(a);
      bField = field(b);
    } else {
      aField = a[field];
      bField = b[field];
    }

    if (insensitive) {
      aField = ('' + aField).toLowerCase().trim();
      bField = ('' + bField).toLowerCase().trim();
    }
    if (trim) {
      aField = ('' + aField).trim();
      bField = ('' + bField).trim();
    }
    var result = (aField > bField) - (aField < bField)
    if (reverse)
      result = -result;
    return result;
  }
}

export function hashCode(s) {
  var hash = 0;
  for (var i = 0; i < s.length; i++) {
    var character = s.charCodeAt(i);
    hash = ((hash << 5) - hash) + character;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
}

export function backgroundStyleFromString(s, options = {}) {
  if (!s) return {};
  const multiplier = options.multiplier || 1;
  var hue = (hashCode(s) * multiplier) % 360;
  if (hue < 0) hue += 360;
  return backgroundStyleFromHue(hue);
}

export function backgroundStyleFromHue(hue) {
  if (typeof hue !== 'number' || !isFinite(hue)) return {};
  var h = hue % 360;
  if (h < 0) h += 360;
  var bgColor = 'hsl(' + Math.floor(h) + ', 100%, 91%)';
  return { 'background-color': bgColor };
}

export function deleteAllKeys(object) {
  if (object instanceof Array) {
    object.splice(0, object.length);
  }
  for (let key in object) {
    if (object.hasOwnProperty(key)) {
      delete object[key];
    }
  }
}

